import React from "react";

const NewPagination = ({
  currentPage = 1,
  limit = 5,
  totalCount = 0,
  onPageChange = () => {},
  onLimitChange = () => {},
  limitOptions = [10, 25, 50, 100],
}) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / limit));
  const startRow = totalCount === 0 ? 0 : (currentPage - 1) * limit + 1;
  const endRow = totalCount === 0 ? 0 : Math.min(currentPage * limit, totalCount);

  const handleFirst = () => onPageChange(1);
  const handleLast = () => onPageChange(totalPages);
  const handlePrev = () => currentPage > 1 && onPageChange(currentPage - 1);
  const handleNext = () => currentPage < totalPages && onPageChange(currentPage + 1);

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    if (currentPage >= totalPages - 3) {
      return [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
  };

  const visible = getVisiblePages();

  return (
    <div className="w-full flex items-center justify-between rounded-md py-2">
      <div className="flex items-center gap-3">
        <span className="text-[13px] font-medium text-[#393A3D]">Rows per page</span>

        <select
          id="limit"
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          className="rounded-[5px] bg-white px-2 py-1 text-sm cursor-pointer outline-none border border-[#D2DAE1] text-[#393A3D]"
        >
          {limitOptions.map((opt) => (
            <option className="text-[13px]" key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>

        <span className="text-sm text-gray-700">
          {startRow}-{endRow} of {totalCount} rows
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={handleFirst}
          disabled={currentPage === 1}
          className="px-2 rounded disabled:opacity-50 text-[#393A3D] border p-1 shadow-[0_0_3.2px_0_rgba(0,0,0,0.20)]"
          aria-label="First page"
        >
          «
        </button>

        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className="px-2 rounded disabled:opacity-50 text-[#393A3D] border p-1 shadow-[0_0_3.2px_0_rgba(0,0,0,0.20)]"
          aria-label="Previous page"
        >
          ‹
        </button>

        {visible.map((p, idx) =>
          p === "..." ? (
            <span key={`dots-${idx}`} className="px-2 text-[#393A3D] select-none">
              ...
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              aria-current={p === currentPage ? "page" : undefined}
              className={`px-2.5 py-1 rounded  ${
                p === currentPage ? "bg-[#004EFF] text-white pointer-events-none" : "hover:bg-gray-200 text-[#393A3D]"
              }`}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="px-2 rounded disabled:opacity-50 text-[#393A3D] border p-1 shadow-[0_0_3.2px_0_rgba(0,0,0,0.20)]"
          aria-label="Next page"
        >
          ›
        </button>

        <button
          onClick={handleLast}
          disabled={currentPage === totalPages}
          className="px-2 rounded disabled:opacity-50 text-[#393A3D] border p-1 shadow-[0_0_3.2px_0_rgba(0,0,0,0.20)]"
          aria-label="Last page"
        >
          »
        </button>
      </div>
    </div>
  );
};

export default NewPagination;
